<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header">
        {{ detail.name }}
        <Tag color="green">{{ detail.type_display }}</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>

      <!-- CREATED DATE -->
      <Row>
        <Col span="12">
          Дата создания:
        </Col>
        <Col span="12">
          {{ formatDateTime(detail.created_date) }}
        </Col>
      </Row>

      <!-- TYPE -->
      <Row>
        <Col span="12">
          Тип:
        </Col>
        <Col span="12">
          {{ detail.type_display }}
        </Col>
      </Row>

      <!-- BALANCE -->
      <Row>
        <Col span="12">
          Баланс:
        </Col>
        <Col span="12"> {{ formatNumber(detail.balance) }} {{ currency }} </Col>
      </Row>
      <Divider>Движение денег</Divider>

      <recentMoneyOrders
        style="min-height: 20%; margin-top: 20px"
        filter_by="account"
        :filter_by_id="id"
      ></recentMoneyOrders>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" @click="cancelAction()">Отмена</Button>
      <Button v-if="display_edit_button" type="primary" @click="editAction()"
        >Редактировать</Button
      >
      <Button
        v-if="display_delete_button"
        type="error"
        @click="deleteAction()"
        style="float: left"
        >Удалить</Button
      >
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { BaseDetailData } from "../../base/base_detail.js";
import recentMoneyOrders from "../../components/core/recentMoneyOrders";

let _app = BaseDetailData();
_app.components = {
  recentMoneyOrders
};
_app.computed.moneyOrderSumColor = function() {
  return this.detail.type === "coming" ? "green" : "red";
};
_app.methods.editAction = function() {
  this.$router.push({
    name: this.item_type + "_edit",
    params: { id: this.id }
  });
};
export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/account/accountDetail.vue